import React, { useEffect, useState, useCallback } from "react";
import { fetchPosts } from "../../api/boardApi";
import PostDetail from "./PostDetail";

const PostList = ({ boardSlug, search, tag }) => {
  const [posts, setPosts] = useState([]);
  const [selectedPostId, setSelectedPostId] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const loadPosts = useCallback(async () => {
    try {
      const params = {};
      if (tag) params.tag = tag;
      if (search) params.search = search;

      const res = await fetchPosts(boardSlug, params);
      setPosts(res.data);
    } catch (err) {
      console.error("❌ 게시글 목록 불러오기 실패", err);
    }
  }, [boardSlug, tag, search]);

  useEffect(() => {
    if (boardSlug) {
      loadPosts();
    }
  }, [boardSlug, loadPosts]);

  // ✅ ESC 키로 닫기
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setDrawerOpen(false);
        setSelectedPostId(null);
      }
    };

    if (drawerOpen) {
      window.addEventListener("keydown", handleKeyDown);
    } else {
      window.removeEventListener("keydown", handleKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [drawerOpen]);

  const handleSelectPost = (postId) => {
    setSelectedPostId(postId);
    setDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setSelectedPostId(null);
  };

  if (!boardSlug) return <p>📂 게시판을 선택해주세요.</p>;

  return (
    <div className="relative">
      <h2 className="text-lg font-bold mb-2">📝 게시글 목록</h2>
      <ul className="space-y-2">
        {posts.map((post) => (
          <li
            key={post.id}
            className="border p-2 rounded shadow cursor-pointer hover:bg-gray-100"
            onClick={() => handleSelectPost(post.id)}
          >
            <h3 className="font-semibold">{post.title}</h3>
            <p className="text-sm text-gray-500">작성자: {post.author_name}</p>
            <p className="text-gray-700 line-clamp-2">{post.content}</p>
          </li>
        ))}
      </ul>

      {/* ✅ 슬라이딩 Drawer */}
      <div
        className={`fixed top-0 right-0 h-full w-full md:w-[480px] bg-white shadow-lg z-50 transform transition-transform duration-300 ${
          drawerOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex justify-end p-4 border-b">
          <button
            onClick={handleCloseDrawer}
            className="text-gray-500 hover:text-black"
          >
            ✖ 닫기
          </button>
        </div>
        <div className="p-4 overflow-y-auto h-[calc(100%-64px)]">
          {selectedPostId && (
            <PostDetail
              postId={selectedPostId}
              boardSlug={boardSlug} // ✅ 필수
              onClose={handleCloseDrawer}
              onDeleted={loadPosts}
            />
          )}
        </div>
      </div>

      {/* ✅ 배경 오버레이 */}
      {drawerOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 z-40"
          onClick={handleCloseDrawer}
        />
      )}
    </div>
  );
};

export default PostList;
